export default function Computed() {
  return function MethodDecorator(
    target: Function,
    ctx: ClassGetterDecoratorContext
  ) {
    const methodName = ctx.name.toString();

    ctx.addInitializer(function () {
      // store information that this field is observed
      if ((this as any).__computedFields === undefined) {
        (this as any).__computedFields = new Set();
      }

      (this as any).__computedFields.add(methodName);
    });
  };
}
